import {Grid, GridItem, Text, Image, Link, Heading} from "@chakra-ui/react"
import Wrapper from "components/layout/wrapper"
import SocialMediaGrid from "components/custom/tht2023/SocialMediaGrid"

export default function Tvt2023SocialMedia() {

    const data = [
        {fn: "Abdel", ln: "Almanfi", twitter: "almanfi_cardio"},
        {
            fn: "Angel",
            ln: "Caldera",
            twitter: "caldera_99",
            img: "https://assets.crfconnect.com/meetings/tct2023/page-content/Angel_Caldera.jpg",
        },
        {
            fn: "Chadi",
            ln: "Alraies",
            twitter: "chadialraies"

        },
        {
            fn: "Jaffar", ln: "Khan", twitter: "CathElectroSurg",
            img: "https://assets.crfconnect.com/meetings/tvt2023/page-content/Jaffar-Khan.jpg"
        },
        {
            fn: "Julio",
            ln: "Farjat Pasos",
            twitter: "Julio_Farjat",
            img: "https://assets.crfconnect.com/meetings/tct2023/page-content/Julio_Farjat.jpg",
        },
        {
            fn: "Lakshmi",
            ln: "Rao",
            twitter: "pagingdr_rao",
            img: "https://assets.crfconnect.com/meetings/tct2023/page-content/Lakshmi_Rao.jpg",
        },
        {fn: "Mirvat", ln: "Alasnag", twitter: "mirvatalasnag"},
        {
            fn: "Oscar",
            ln: "Mendiz",
            twitter: "Omendiz",
            img: "https://assets.crfconnect.com/meetings/tct2023/page-content/Oscar_Mendiz.jpg",
        },
        {fn: "Shariq", ln: "Shamim", twitter: "ShariqShamimMD"},
        {
            fn: "Tiffany",
            ln: "Chen",
            twitter: "tiffchenMD",
            img: "https://assets.crfconnect.com/meetings/tct2023/page-content/Tiffany_Chen.jpg",
        },
    ]

    return (
        <Wrapper>
            <SocialMediaGrid data={data}/>
        </Wrapper>
    )
}
